import { z } from "zod";

/**
 * User.tracking — arbitrary key-value analytics properties.
 * Stored as Record<string, string> for Segment / Mixpanel identification.
 *
 * Note: _v versioning is omitted here because ZodRecord validates every
 * key uniformly — there is no place to add a reserved _v field without
 * changing the stored data shape. The schema is intentionally unversioned.
 */
export const TrackingSchema = z.record(z.string(), z.string());

export type Tracking = z.infer<typeof TrackingSchema>;
